module.exports = __webpack_public_path__ + "static/media/hight_direct_marketing_capaign.cc7e696e.png";